import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

export interface Locale {
  lang: string;
  data: Object;
}

@Injectable({
  providedIn: 'root'
})
export class CoreTranslationService {
  private activeLang: string;
  /**
   * Constructor
   *
   * @param _translateService
   */
  constructor(private _translateService: TranslateService,
    @Inject(DOCUMENT) private document: any
  ) {}

  // Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Translate
   *
   * @param args
   */
  translate(...args: Locale[]): void {
    const locales = [...args];

    locales.forEach(locale => {
      // use setTranslation() with the third argument value as true to append translations instead of replacing them
      this._translateService.setTranslation(locale.lang, locale.data, true);
    });
  }

  public getActiveLang(): string {
    return this.activeLang;
  }

  public setActiveLang(lang: string): void {
    this.activeLang = lang;
    this.document.documentElement.lang = lang;
  }

  public changeLang(lang: string): void {
    this.activeLang = lang;
    this._translateService.use(lang);
    this.document.documentElement.lang = lang;
  }
}
